export default __webpack_public_path__ + "static/media/result-sheet-icon.f1117454.svg";